import { Seller } from "./Seller";

export interface CollectionNode {
    id: ID;
    path: string;
    object: CollectionNodeObject;
    sequence: number;
    seller: Seller;
    name?: string;
    breadcrumb?: string;
    description?: string;
    photo?: { id: ID; src?: string; type?: string; title?: string } | null;
    product?: { id: ID };
    createdAt?: string;
    updatedAt?: string;
    childrenCount?: {
        group_collection_node: number;
        product_collection_node: number;
        catalog_item_collection_node: number;
    };
}

export enum CollectionNodeObject {
    GROUP_COLLECTION_NODE = "group_collection_node",
    PRODUCT_COLLECTION_NODE = "product_collection_node",
    CATALOG_ITEM_COLLECTION_NODE = "catalog_item_collection_node",
}

export enum CollectionNodeSequences {
    COLLECTION_NODE_SEQUENCE_INCREMENT = 1000,
    COLLECTION_NODE_SEQUENCE_START = 100_000,
}

export const MAX_COLLECTION_NESTING_DEPTH = 2;
